// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4299":"1a349ac81ec3f991","7333":"0779a25d637faefe"}[chunkId] + ".css";
};